import { BerRatings } from '@/types';
import { GammaAPIService } from '../service/gamma-api.service';
import { defineStore } from 'pinia'
import { LngLatLike } from "mapbox-gl";

interface SettingsState {
  berRatings: BerRatings | undefined;
  coords: LngLatLike | undefined;
}

export const useBerRatings = defineStore('ber-ratings', {
  state: (): SettingsState => ({
    berRatings: undefined,
    coords: undefined
  }),
  getters: {
  },
  actions: {
    async loadBerRatingByCoords(lat: number, lng: number) {
      try {
        this.berRatings = await GammaAPIService.getBerRatings(lat, lng);
        this.coords = { lat, lng };
      } catch(e) {
        console.error(e)
      }
    },
  },
});

